import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  InputGroupText,
  InputGroup,
  FormCheckbox,
  InputGroupAddon,
  FormSelect,
  FormInput,
  Row,
  Col,
  Button,
  Container,
  Form,
} from "../components/ui";
import { Modal, ModalHeader, ModalBody } from "../components/ui";
import { withRouter } from "../hooks/withRouter";
import { Link } from "react-router-dom";
import PageTitle from "../components/common/PageTitle";
import SidebarActions from "../components/add-new-post/SidebarActions";
import SuggestedPost from "components/common/post";
import JoditEditor from "jodit-react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { getWistiaConfig, getPost, getEducationalPosts } from "../api";
import PostData from "views/Post/postData";
import publisherStore from "../flux/publisherStore";

const editorConfig = {
  uploader: {
    url: `${process.env.REACT_APP_API_URL}media/image`,
    isSuccess: function (resp) {
      return true;
    },
    process: function (resp) {
      return {
        files: [resp.url],
        path: resp.url,
        baseurl: resp.url,
        error: false,
        message: "",
      };
    },
    defaultHandlerSuccess: function (data) {
      const editor = this.jodit || this;
      editor.selection.insertImage(data.baseurl);
    },
  },
  spellcheck: true,
  toolbarAdaptive: false,
  buttons:
    "bold,strikethrough,underline,italic,eraser,ul,ol,outdent,indent,image,video,font,fontsize,brush,paragraph,file,table,link,align,undo,redo,fullsize,preview",
  placeholder: "",
  readOnly: false,
};

const excerptConfig = {
  spellcheck: false,
  toolbarAdaptive: false,
  buttons: "paragraph,bold,italic,underline,eraser,ul,ol,link",
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  placeholder: "",
  readOnly: false,
};

class AddNewPost extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      content: "",
      image: "",
      contentType: false,
      wistiaConfig: null,
      embeddedVideo: null,
      publishers: [],
      suggestedPosts: [],
      suggestedPublisher: "",
      suggestedPostsSearchResults: [],
      src: null,
      modal: false,
      crop: {
        unit: "%",
        width: 30,
        aspect: 16 / 9,
      },
    };
    this.excerptEditorRef = React.createRef();
    this.contentEditorRef = React.createRef();
  }

  componentDidMount = async () => {
    const postId = this.props.match?.params?.postId;

    let post;
    const wistiaConfig = await getWistiaConfig();
    this.setState({
      wistiaConfig: wistiaConfig.data,
    });
    if (!!postId) {
      post = await getPost(postId);
      const posts = post.data.suggestedPostIds.map(async (postId) => {
        let suggestedData = await getPost(postId);
        return suggestedData.data;
      });
      const suggestedPostsData = await Promise.all(posts);

      this.setState({
        post: post.data,
        postId: postId,
        title: post.data.title,
        description: post.data.excerpt,
        content: post.data.content,
        tags: post.data.tags,
        croppedImageUrl: post.data.image.original,
        suggestedPosts: suggestedPostsData,
      });
      if (post.data.contentTypeId === 2) {
        this.initVideoUpload(wistiaConfig.data);
      }
    }
  };

  addPost = (post) => {
    const postId = post && post.id;
    const posts = this.state.suggestedPosts;
    const hasPostAlready = !!posts.find((post) => post.id === postId);
    if (!hasPostAlready) {
      this.setState({ suggestedPosts: [...posts, post] });
    }
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    let publishers = this.getPublishers();
    if (
      prevState.publishers.length === 0 &&
      publishers &&
      publishers.length !== 0
    ) {
      this.setState({ publishers: publishers });
    }
  };

  clearSuggested = () => {
    this.setState({ searchLine: "", suggestedPostsSearchResults: [] });
  };

  searchSuggested = async (search) => {
    this.setState({
      searchLine: search.target.value,
    });
    let data = {
      authorIds:
        this.state.suggestedPublisher !== ""
          ? [this.state.suggestedPublisher]
          : [],
      educationOnly: false,
      searchString: search.target.value,
    };
    const res = await getEducationalPosts(data, 10, 0);
    this.setState({ suggestedPostsSearchResults: res.data.items });
  };

  toggleModal = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  changeSuggestedPublisher = (event) => {
    this.setState({ suggestedPublisher: parseInt(event.target.value) }, () => {
      this.searchSuggested({
        target: {
          value: "",
        },
      });
    });
  };

  setTitle = (event) => {
    this.setState({
      title: event.target.value,
      slug: event.target.value.toLocaleLowerCase().split(" ").join("-"),
    });
  };

  setDescription = (event) => {
    this.setState({ description: event });
  };

  contentType = () => {
    this.setState({ contentType: !this.state.contentType }, () => {
      if (this.state.contentType) {
        this.initVideoUpload(this.state.wistiaConfig);
      }
    });
  };

  setContent = (event) => {
    this.setState({ content: event });
  };

  setSlug = (event) => {
    this.setState({ slug: event.target.value });
  };

  setImage = (event) => {
    var self = this;
    var files = event.target.files;
    var file = files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      self.setState({ image: reader.result });
    };
  };

  initVideoUpload = (config) => {
    var self = this;
    window._wapiq = window._wapiq || [];
    window._wapiq.push((W) => {
      window.wistiaUploader = new W.Uploader({
        accessToken: config.accessToken,
        dropIn: "wistia_uploader",
        projectId: config.projectId,
        projectName: config.projectName,
      });
      window.wistiaUploader.bind(
        "uploadembeddable",
        (file, media, embedCode, oembedResponse) => {
          self.setState({
            embeddedVideo: {
              mediaId: media.id,
              thumbnailUrl: media.thumbnail.url,
              embedCode: embedCode,
            },
          });
        }
      );
    });
  };

  reloadContent = (post) => {
    this.setState({ post: post, content: post.content });
  };

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({ src: reader.result })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = (image) => {
    this.imageRef = image;
  };

  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "newFile.jpeg"
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      const base64Image = canvas.toDataURL("image/jpeg");
      resolve(base64Image);
    });
  }

  removeSuggestedPost = (id) => {
    const posts = this.state.suggestedPosts.filter((p) => p.id !== id);
    this.setState({
      suggestedPosts: posts,
    });
  };

  onTagsUpdate = (tags) => {
    this.setState({ post: { ...this.state.post, tags } });
  };

  getCurrentUser() {
    const user = localStorage.getItem("user");
    return user && JSON.parse(user);
  }

  getPublishers() {
    const publishers = publisherStore.getPublishers();
    return publishers;
  }

  onChangePublisher = (id) => {
    this.setState({ adminSelectedPublisherId: id });
  };

  getPublisherForPreview() {
    const postPublisher =
      this.state && this.state.post && this.state.post.publisher;

    if (postPublisher) {
      // this means that post has already been published so there is already an assosiated publisher
      return postPublisher;
    }

    const publishers = this.getPublishers();

    if (this.isUserAdmin()) {
      if (!this.state.adminSelectedPublisherId) {
        return null;
      }

      return (
        publishers &&
        publishers.find(
          (publisher) =>
            Number(publisher.id) === Number(this.state.adminSelectedPublisherId)
        )
      );
    }

    return (
      publishers &&
      publishers.find((publisher) => publisher.id === this.getCurrentUser().id)
    );
  }

  isUserAdmin = () => {
    const user = this.getCurrentUser();

    const isAdmin = user && user.userRoleId === 1;
    return isAdmin;
  };

  onSidebarUpdate = (sidebarState) => {
    this.setState({ post: { ...this.state.post, ...sidebarState } });
  };

  onPostCreation = (id) => {
    this.setState({ post: { ...this.state.post, id } });
  };

  onStatusChange = (isDraft) => {
    this.setState({ post: { ...this.state.post, isDraft } });
  };

  render() {
    const { postId } = this.props.match?.params || {};
    const { post, crop, croppedImageUrl, src } = this.state;
    return (
      <Container fluid className="main-content-container px-4 pb-4">
        {this.state.preview ? (
          <Modal
            size="lg"
            isOpen={this.state.preview}
            toggle={() => {
              this.setState({ preview: !this.state.preview });
            }}
          >
            <ModalBody>
              <Card small className="post-overview">
                <PostData
                  isPreview
                  post={{
                    ...post,
                    title: this.state.title,
                    content: this.state.content,
                    excerpt: this.state.description,
                    contentAvailabilityId: 1,
                    embeddedVideo:
                      this.state.embeddedVideo || (post && post.embeddedVideo),
                    croppedImageUrl,
                    publisher: this.getPublisherForPreview(),
                    user: {},
                  }}
                  isPublicAccessClass={() => undefined}
                ></PostData>
                {this.state.suggestedPosts.length > 0 && (
                  <div className="suggested-posts">
                    <Row>
                      <Col lg="12">
                        <span className="title">Suggested Posts</span>
                      </Col>
                      {this.state.suggestedPosts.map((post, idx) => (
                        <SuggestedPost key={idx} col="4" post={post} />
                      ))}
                    </Row>
                  </div>
                )}
              </Card>
            </ModalBody>
          </Modal>
        ) : null}
        <Row noGutters className="page-header py-4">
          <Col md="9">
            {!postId && (
              <PageTitle
                sm="4"
                title={`Add New ${
                  this.state.contentType ? "Video" : "Text"
                } Post`}
                subtitle="Blog Posts"
                className="text-sm-left"
              />
            )}
            {postId && !!post && (
              <PageTitle
                sm="4"
                title={`Editing ${this.state.post.title}`}
                subtitle="Blog Posts"
                className="text-sm-left"
              />
            )}
          </Col>
          <Col md="3" style={{ position: "relative" }}>
            <Button
              title="preview-post"
              style={{ position: "absolute", bottom: 0, right: 0 }}
              size="sm"
              onClick={() => {
                this.setState({ preview: true });
              }}
            >
              <i className="material-icons">visibility</i>
            </Button>
          </Col>
        </Row>

        <Row>
          {/* Editor */}
          <Col lg="8" md="12">
            <Card className="mb-3">
              <CardBody>
                <Form className="add-new-post">
                  {!postId && (
                    <span
                      style={{ alignItems: "center" }}
                      className="d-flex mb-2"
                    >
                      <strong className="mr-1">Content type :</strong>{" "}
                      <FormCheckbox
                        toggle
                        small
                        checked={this.state.contentType}
                        onChange={this.contentType}
                      >
                        {this.state.contentType ? "Video" : "Text"}
                      </FormCheckbox>
                    </span>
                  )}
                  <FormInput
                    size="lg"
                    className="mb-3"
                    placeholder="Your Post Title"
                    onChange={this.setTitle}
                    value={this.state.title}
                  />
                  {!postId && (
                    <FormInput
                      size="lg"
                      className="mb-3"
                      placeholder="Slug"
                      onChange={this.setSlug}
                      value={this.state.slug}
                    />
                  )}
                  Excerpt
                  <JoditEditor
                    ref={this.excerptEditorRef}
                    value={this.state.description}
                    config={excerptConfig}
                    tabIndex={1}
                    onBlur={(newContent) => this.setDescription(newContent)}
                  />
                  <br />
                  Content
                  <JoditEditor
                    ref={this.contentEditorRef}
                    value={this.state.content}
                    config={editorConfig}
                    tabIndex={1}
                    onBlur={(newContent) => this.setContent(newContent)}
                  />
                  {this.state.contentType && <div id="wistia_uploader"></div>}
                  {post && post.contentTypeId === 2 && (
                    <div id="wistia_uploader"></div>
                  )}
                  {post && post.contentTypeId === 2 && post.embeddedVideo && (
                    <div>
                      <br />
                      Previous video: <br />
                      <img
                        src={post.embeddedVideo.thumbnailUrl}
                        alt="prev video"
                      ></img>
                      <br />
                      <br />
                      <div id="wistia_uploader"></div>
                    </div>
                  )}
                  <br />
                  <div className="custom-file mb-3">
                    <input
                      type="file"
                      className="custom-file-input"
                      id="customFile2"
                      onChange={this.onSelectFile}
                    />
                    <label className="custom-file-label" htmlFor="customFile2">
                      Select image ...
                    </label>
                    {src && (
                      <ReactCrop
                        src={src}
                        crop={crop}
                        ruleOfThirds
                        onImageLoaded={this.onImageLoaded}
                        onComplete={this.onCropComplete}
                        onChange={this.onCropChange}
                      />
                    )}
                  </div>
                </Form>
              </CardBody>
            </Card>
            <Card className="mb-3">
              <CardHeader className="border-bottom">
                <h6 className="m-0">Header Preview</h6>
              </CardHeader>
              <CardBody className="p-0">
                {croppedImageUrl && (
                  <img
                    alt="Crop"
                    style={{ maxWidth: "100%" }}
                    src={croppedImageUrl}
                  />
                )}
                <br />
                <br />
              </CardBody>
            </Card>
            <Card className="mb-3">
              <CardHeader className="border-bottom">
                <h6 className="m-0">Suggested Posts</h6>
              </CardHeader>
              <CardBody>
                <Row>
                  <Button
                    onClick={() => {
                      this.setState({ modal: true });
                    }}
                  >
                    Search
                  </Button>
                </Row>
                <Row>
                  <ListGroup small flush className="list-group-small">
                    {this.state.suggestedPosts.map((post) => (
                      <ListGroupItem key={post.id} className="d-flex px-3">
                        <div
                          key={post.id}
                          className="blog-comments__item d-flex p-3"
                        >
                          <i
                            className="material-icons suggested-remove"
                            onClick={() => this.removeSuggestedPost(post.id)}
                          >
                            clear
                          </i>
                          <div className="blog-comments__avatar mr-3">
                            <img
                              src={post.image.small}
                              alt={post.image.small}
                            />
                          </div>
                          <div className="blog-comments__content">
                            <div className="blog-comments__meta text-mutes">
                              <Link className="text-secondary" to={post.url}>
                                {post.title}
                              </Link>
                            </div>
                            <p className="m-0 my-1 mb-2 text-muted">
                              Published by {post.author.name} on{" "}
                              {post.publishedAt}
                            </p>
                          </div>
                        </div>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4" md="12">
            <SidebarActions
              onChangePublisher={this.onChangePublisher}
              onSidebarUpdate={this.onSidebarUpdate}
              onPostCreation={this.onPostCreation}
              onTagsUpdate={this.onTagsUpdate}
              reloadContent={this.reloadContent}
              suggested={this.state.suggestedPosts}
              onSelectEducationalTopic={(selectedTopics, sidebarState) =>
                this.setState({
                  post: {
                    ...this.state.post,
                    ...sidebarState,
                    educationTopics: selectedTopics,
                  },
                })
              }
              post={this.state.post}
              title={this.state.title}
              description={this.state.description}
              content={this.state.content}
              image={
                this.state.croppedImageUrl === undefined
                  ? this.state.url
                  : this.state.croppedImageUrl
              }
              type={this.state.contentType}
              video={this.state.embeddedVideo}
            />
          </Col>
        </Row>

        {this.state.modal ? (
          <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
            <ModalHeader toggle={this.toggleModal}>
              Suggested Post Selection
            </ModalHeader>
            <ModalBody>
              <ListGroup flush>
                <ListGroupItem className="p-3">
                  <span className="d-flex mb-2">
                    <FormSelect
                      id="feInputState"
                      onChange={this.changeSuggestedPublisher}
                    >
                      <option>Choose publisher ...</option>
                      {this.state.publishers.map((publisher) => (
                        <option key={publisher.id} value={publisher.id}>
                          {publisher.name}
                        </option>
                      ))}
                    </FormSelect>
                  </span>
                  <InputGroup seamless>
                    <FormInput
                      size="lg"
                      placeholder="Search term ..."
                      onChange={this.searchSuggested}
                      value={this.state.searchLine}
                    />
                    <InputGroupAddon type="append">
                      <InputGroupText onClick={this.clearSuggested}>
                        <i className="material-icons">clear</i>
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </ListGroupItem>
                <br />
                <ListGroupItem className="p-3">
                  <ListGroup small flush className="list-group-small">
                    {this.state.suggestedPostsSearchResults.map((post) => (
                      <ListGroupItem key={post.id} className="d-flex px-3">
                        <div
                          key={post.id}
                          className="blog-comments__item d-flex p-3"
                        >
                          <FormCheckbox
                            className="mb-1"
                            onChange={() => this.addPost(post)}
                            checked={
                              this.state.suggestedPosts
                                .map((t) => t.id)
                                .indexOf(post.id) !== -1
                            }
                          ></FormCheckbox>
                          <div className="blog-comments__avatar mr-3">
                            <img
                              src={post.image.small}
                              alt={post.image.small}
                            />
                          </div>
                          <div className="blog-comments__content">
                            <div className="blog-comments__meta text-mutes">
                              <Link className="text-secondary" to={post.url}>
                                {post.title}
                              </Link>
                            </div>
                            <p className="m-0 my-1 mb-2 text-muted">
                              Published by {post.author.name} on{" "}
                              {post.publishedAt}
                            </p>
                          </div>
                        </div>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </ListGroupItem>
              </ListGroup>
            </ModalBody>
          </Modal>
        ) : null}
      </Container>
    );
  }
}

export default withRouter(AddNewPost);
